module.exports = __webpack_public_path__ + "img/logo.29c5ee1d.png";